import React from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import history from './history/history';
import './App.scss';
import { PrivateRoute } from './components/PrivateRoute';

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const Logout = React.lazy(() => import('./components/Logout'));
const ForgotPassword = React.lazy(() => import('./components/forgotPassword/forgotPassword'));
const SSO = React.lazy(() => import('./components/SSO'));

function App() {
	return (
		<Router history={history}>
			<React.Suspense fallback={loading()}>
				<Switch>
					<Redirect from="/" to="/sso" exact />
					<Route exact path="/sso" name="SSO" render={(props) => <SSO {...props} />} />
					<Route
						// exact
						path="/reset-password"
						name="Reset Password"
						render={(props) => <ForgotPassword {...props} />}
					/>
					{/* <Route path="/admin" name="Home" component={DefaultLayout} /> */}
					<PrivateRoute path="/admin" name="Home" component={DefaultLayout} />
					<PrivateRoute path="/logout" name="Logout" component={Logout} />
					<Redirect path="**" to="/" />
				</Switch>
			</React.Suspense>
		</Router>
	);
}

export default App;
